<template>
    <div>
        <modal-alert v-if="onalert" :onalert="onalert" :alert="alert" :number="number" :count="count" @onclose="onalert = false" @confirm="CONFIRM"/>
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Ruta de Entrega</h1>
                                    <p class="text-sm text-muted mb-0">Documento de Entrega #<b>{{ data.id }}</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="card" v-if="data.state_id == 25">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Ruta de Entrega</h5>
                        </div>
                        <div class="card-body">
                            <div>
                                <form @submit.prevent="SEARCH()" class="d-flex gap-3 row">
                                    <div class="col-lg-11 col-sm-10 col-9 px-0">
                                        <div class="input-group input-group-inline">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text pe-2 text-sm">GV</span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="Buscar..." ref="number" v-model="number">
                                        </div>
                                    </div>
                                    <div>
                                        <button type="submit" :disabled="!number" class="btn px-3 btn-primary">
                                            <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'search'">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <span v-else>Buscar</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 py-3" v-if="loading == 'data'">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-else>
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Paquetes Agregados</h5>
                        </div>
                        <div class="card-body p-0">
                            <template v-if="data.packages.length > 0">
                                <v-data-table class="elevation-1 table-sm" 
                                    :headers="headers.filter( (e, i) => { if(data.state_id == 25){ return e }else{ if(i >= 0){ return e } } })"
                                    :items="data.packages"
                                    v-model="selected"
                                    dense
                                    :show-select="data.state_id == 25">
                                    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }" v-if="data.state_id == 25">
                                        <v-simple-checkbox
                                            :ripple="false"
                                            :value="isSelected"
                                            @input="select($event)">
                                        </v-simple-checkbox>
                                    </template>
                                    <template v-slot:[`item.user.address_or_branch`]="{ item }">
                                        <div v-html="item.user.address_or_branch"></div>
                                    </template>
                                    <template v-slot:[`item.route`]="{ item }">
                                        {{ data.route.full_name }}
                                    </template>
                                    <template v-slot:[`item.id`]="{ item }">
                                        <router-link
                                            :to="{ name: 'PackageUpdate', params: { id: item.id } }"
                                            class="text-decoration-none">
                                            {{ item.type }}{{ item.id }}
                                        </router-link>
                                    </template>
                                </v-data-table>
                            </template>
                            <div class="w-100 py-3" v-else>
                                <p class="text-sm text-muted text-center mb-0">No hay resultados.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-end" v-if="data.packages.length > 0 && data.state_id == 25">
                        <button type="button" @click="REMOVE()" :disabled="selected.length == 0" class="btn btn-h px-3 btn-danger">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'remove'">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else><b>-</b> Quitar seleccionados</span>
                        </button>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
import ModalAlert from './modals/Alert'
export default {
    components: { ModalAlert },
    data() {
        return {
            loading: '',
            headers: [
                { text: 'GVT', value: 'id' },
                { text: 'Cliente', value: 'user.name' },
                { text: 'Dirección', value: 'user.address_or_branch' },
                { text: 'Ruta Asignada', value: 'route' }
            ],
            data: {
                id: '',
                packages: []
            },
            selected: [],
            number: '',
            count: 0,
            id: this.$route.params.id,
            onalert: false,
            alert: '',
        }
    },
    mounted() {
        let vue = this
        vue.INIT()
        if(vue.$refs.number){
            vue.$nextTick(() => vue.$refs.number.focus())
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = 'data'
            axios({url: '/deliver-routes/' + vue.id + '/packages', method: 'GET' })
                .then((resp) => {
                    vue.data= resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = ''
                })
        },
        SEARCH: function(){
            let vue = this
            vue.count++
            vue.loading = 'search'
            if (vue.count == 1) {
                axios({url: 'validated/deliver/packages/save', method: 'POST', data: {id: vue.number, deliver_route_id: vue.data.id} })
                    .then((resp) => {
                        vue.count = 0
                        vue.CONFIRM(resp.data.number)
                    })
                    .catch((err) => {
                        if (err.response.status === 402) {
                            vue.onalert = true
                            vue.alert = err.response.data.message
                            vue.number = err.response.data.number
                        }else if(err.response.status === 404){
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.count = 0
                        vue.loading = ''
                    })
            }
        },
        CONFIRM: function(number){
            let vue = this
            vue.count++
            vue.loading = 'confirm'
            if (vue.count == 1) {
                axios({url: 'deliver/packages/save', method: 'POST', data: {id: number, deliver_route_id: vue.data.id} })
                    .then((resp) => {
                        vue.data.packages.push(resp.data.data)
                        vue.number = ''
                        let message = resp.data.message
                        message = message.replace(':full_name', vue.data.route.full_name)
                        vue.$swal({ toast: true, icon: 'success', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                        vue.loading = ''
                        vue.onalert = false
                        vue.alert = ''
                        if(vue.$refs.number){
                            vue.$nextTick(() => vue.$refs.number.focus())
                        }
                    })
            }
        },
        REMOVE: function(){
            let vue = this
            vue.count++
            vue.loading = 'remove'
            if (vue.count == 1) {
                let ids = vue.selected.map(e => e.id)
                axios({url: 'deliver/packages/remove', method: 'POST', data: { deliver_route_id: vue.data.id, ids: JSON.stringify(ids) } })
                    .then((resp) => {
                        vue.selected.forEach(element => {
                            vue.data.packages.splice(vue.data.packages.findIndex(e => e.slug == element.slug), 1)
                        })
                        vue.number = ''
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                        vue.loading = ''
                        vue.selected = []
                        if(vue.$refs.number){
                            vue.$nextTick(() => vue.$refs.number.focus())
                        }
                    })
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/delivery-routes/Packages.vue